import React, { useEffect, useState } from 'react';
import MyMasonry from '../../components/Mansory/Mansory';
import { SupportRequest, getSupportRequests } from '../../hooks/api-methods/useSupport';
import CustomDropdown from '../../components/Buttons/Dropdown';
import SearchInput from '../../components/Inputs/SearchInput'; // ✅ import reusable component
import Loader from '../../components/Loader/Loader';
import { useScreenSize } from '../../hooks/useScreenSize';

const SupportManager: React.FC = () => {
  const [subscription, setSubscription] = useState<SupportRequest[]>([]);
  const [filteredSubject, setFilteredSubject] = useState<string>('all');
  const [searchTerm, setSearchTerm] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(true);
  const { isMobile } = useScreenSize();

  useEffect(() => {
    const fetchTemplates = async () => {
      try {
        const data = await getSupportRequests();
        setSubscription(data);
        setLoading(false);
      } catch (err) {
        console.error('Error fetching templates:', err);
      }
    };

    fetchTemplates();
  }, []);

  const subjectOptions = ['all', ...Array.from(new Set(subscription.map((item) => item.subject)))];

  const filteredMessages = subscription.filter((msg) => {
    const matchesSubject = filteredSubject === 'all' || msg.subject === filteredSubject;
    const matchesName = msg.name.toLowerCase().includes(searchTerm.toLowerCase());
    return matchesSubject && matchesName;
  });

  if (loading) {
    return <Loader />;
  }

  return (
    <div className="flex-column gap-2 w-100">
      <h3>Manage Messages</h3>

      <div className={`ptb-1 ${isMobile ? 'flex-colomn' : 'flex-row gap-2 space-between '}`}>
        <SearchInput
          value={searchTerm}
          onChange={setSearchTerm}
          placeholder="Search by name..."
          width="300px"
        />

        <CustomDropdown
          options={subjectOptions}
          value={filteredSubject}
          onChange={(val) => setFilteredSubject(val)}
          textInput="Filter by subject"
        />
      </div>

      <MyMasonry
        items={filteredMessages}
        renderItem={(sub: SupportRequest) => (
          <div className="card-mail card--shadow w-100 p-1">
            <h4>
              <strong>Subject:</strong> {sub.subject}
            </h4>
            <p>
              <strong>Name:</strong> {sub.name}
            </p>
            <p>
              <strong>Phone:</strong> {sub.phone}
            </p>
            <p>
              <strong>Email:</strong> {sub.email}
            </p>
            <p>
              <strong>Note:</strong> {sub.note}
            </p>
            <p>
              <strong>Conditions:</strong> {sub.conditions ? 'Yes' : 'No'}
            </p>

            <div className="flex-row justify-end">
              <a
                href={`mailto:${sub.email}?subject=${encodeURIComponent(
                  `RE: ${sub.subject}`,
                )}&body=${encodeURIComponent(
                  `Beste ${sub.name},\n\nBedankt voor uw bericht.\n\nMet vriendelijke groet,\n[Your Name]`,
                )}`}
                className="btn btn-small btn-second-color"
              >
                Reply
              </a>
            </div>
          </div>
        )}
      />

      {filteredMessages.length === 0 && <p className="w-100 vh-75">No messages found.</p>}
    </div>
  );
};

export default SupportManager;
